
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How much do painters and decorators charge in Watford?',
      answer: 'Professional <strong>painters and decorators in Watford</strong> typically charge between £150-£250 per day depending on the project complexity. At Brushour, we provide free, no-obligation quotes tailored to your specific needs. Prices vary based on room size, surface preparation required, and paint quality. Contact us for an accurate estimate for your <strong>painting project in Watford</strong>, Rickmansworth, or surrounding Hertfordshire areas.'
    },
    {
      question: 'How long does it take to paint a house in Watford?',
      answer: 'A typical 3-bedroom house interior in <strong>Watford</strong> takes 5-7 days to paint professionally, including preparation and drying time. Exterior painting usually takes 3-5 days depending on weather conditions. Brushour\'s experienced <strong>decorators</strong> work efficiently while maintaining the highest quality standards. We provide realistic timelines during our free consultation and keep disruption to your Watford home minimal.'
    },
    {
      question: 'Do you provide free quotes in Watford and Hertfordshire?',
      answer: 'Yes! Brushour provides completely free, no-obligation quotes throughout <strong>Watford</strong>, Rickmansworth, Chorleywood, Northwood, and all surrounding <strong>Hertfordshire</strong> areas. We visit your property, assess the work required, discuss your preferences, and provide a detailed written quote. There\'s no pressure to proceed, and our quotes are valid for 30 days.'
    },
    {
      question: 'Are Brushour painters and decorators fully insured?',
      answer: 'Absolutely. Brushour carries full public liability insurance up to £1 million, protecting your <strong>Watford</strong> property throughout the <strong>painting and decorating</strong> process. We\'re also fully qualified with 18+ years of experience serving <strong>Hertfordshire</strong> homeowners and businesses. All our work is guaranteed, giving you complete peace of mind when choosing our decorating services.'
    },
    {
      question: 'What areas around Watford do you cover?',
      answer: 'Brushour proudly serves <strong>Watford</strong> and all surrounding <strong>Hertfordshire</strong> areas including Rickmansworth, Chorleywood, Northwood, Pinner, Bushey, Radlett, and Gerrards Cross. We\'re <strong>local painters and decorators</strong> who understand the specific needs of properties in these areas. Our team travels throughout Hertfordshire providing the same high-quality <strong>painting and decorating services</strong> to every client.'
    },
    {
      question: 'What painting services does Brushour offer in Watford?',
      answer: 'Brushour offers comprehensive <strong>painting and decorating services in Watford</strong> including interior painting, exterior painting, wallpaper installation and removal, limewash painting, spray painting, colour consultation, and both residential and commercial decorating. We handle everything from single rooms to complete property transformations across <strong>Hertfordshire</strong>, using premium materials and expert techniques.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm font-medium tracking-wider uppercase text-amber-600 mb-3">FAQ</p>
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-700 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-base text-neutral-600 max-w-2xl mx-auto">
            Common questions about our <strong>painting and decorating services in Watford</strong> and surrounding Hertfordshire areas
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-beige-50 rounded-lg shadow-md overflow-hidden border border-beige-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-beige-100 transition-colors cursor-pointer"
              >
                <h4 className="text-lg font-semibold text-neutral-800 pr-4">
                  {faq.question}
                </h4>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-amber-600 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div
                  className="px-6 pb-5 text-sm text-neutral-600 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: faq.answer }}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-base text-neutral-600 mb-4">
            Still have questions about our <strong>painting services in Watford</strong>?
          </p>
          <a
            href="tel:+441234567890"
            className="inline-flex items-center gap-2 px-8 py-3 bg-sky-500 text-white text-base font-semibold rounded-lg hover:bg-sky-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-xl"></i>
            Call Us Today
          </a>
        </div>
      </div>
    </section>
  );
}
